<mat-accordion multi>
  <mat-expansion-panel [expanded]="expanded">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Détail des pièces
      </mat-panel-title>
      <mat-panel-description class="">
        {{ panelDescription }}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div *ngIf="prop && canUpdateProperty" class="d-flex flex-row-reverse mb-2">
      <button mat-mini-fab color="primary" (click)="add()">
        <mat-icon appTooltip="Ajouter une pièce">add</mat-icon>
      </button>
    </div>
    <div class="w-100" *ngIf="dataSource && dataSource.data.length > 0; else noData">
      <div class="d-flex flex-column flex-sm-row">
        <mat-form-field>
          <mat-icon matPrefix color="primary">search</mat-icon>
          <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Rechercher" />
        </mat-form-field>
        <mat-slide-toggle (change)="toggleDisplayColumns()" [checked]="displayFullColumns" class="m-3 no-mobile">Plus de
          détails</mat-slide-toggle>
      </div>
      <div [class]="tableClass">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
            <td mat-cell *matCellDef="let row" class="main">{{ row.name }}</td>
          </ng-container>
          <ng-container matColumnDef="surface">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Surface</th>
            <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.surface ?
              (row.surface |
              decimalFormat) + ' m²' : '' }}</td>
          </ng-container>
          <ng-container matColumnDef="level">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Niveau</th>
            <td mat-cell *matCellDef="let row">{{ row.level }}</td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
            <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.type }}</td>
          </ng-container>
          <ng-container matColumnDef="exposure">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Exposition</th>
            <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.exposure }}</td>
          </ng-container>
          <ng-container matColumnDef="openingTypes">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Type d'ouvertures</th>
            <td mat-cell *matCellDef="let row">{{ row.openingTypes | commaStringArray }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
    <ng-template #noData>
      <span class="no-content dark">Aucune pièce n'est renseignée</span>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li>
        <a (click)="edit(row.room)"><mat-icon color="primary">create</mat-icon><span class="text">Modifier la
            pièce</span></a>
      </li>
      <li>
        <a (click)="confirmDelete(row.room)">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer la pièce</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>
